module.exports = __webpack_public_path__ + "media/public/images/logo-be3c57f7ebbf7deed79c048bd2abdc27.png";